import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import TabOneView from '../tabOneView/tabOneView';
import TabTwoView from '../tabTwoView/tabTwoView';
import TabThreeView from '../tabThreeView/tabThreeView';
import './membersTabularView.scss';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveTab } from '../../../state/tabularSlice';
import { useEffect, useState } from 'react';
import { IRootState } from '../../../state/store';
import { IEmpInfoData, ISchDataList, ISchData, ISchList } from 'types/listOfEmployees';
import { IPayByPayStart } from 'types/viewInfomation';
import useUserStore from 'zustands/useUserStore';

interface IProps {
  empData: IEmpInfoData | null;
  infoData: IEmpInfoData | null;
  schData: ISchDataList[];
  date: Date;
  handleSelectDate: (date: Date) => void;
  payData: IPayByPayStart;
  monthPayData: { [key: string]: string } | null;
  toggleWorkType: () => Promise<void>;
  removeSch: (deleteSchList: string[]) => Promise<void>;
}

const MembersTabularView = ({
  empData,
  infoData,
  schData,
  date,
  handleSelectDate,
  payData,
  monthPayData,
  toggleWorkType,
  removeSch,
}: IProps) => {
  const dispatch = useDispatch();
  const { userType, managerInfo } = useUserStore();

  const selected = useSelector((state: IRootState) => state.tabs.selectedHeader);
  const editableEmpInfo = userType === '1' || managerInfo.otherPayShow;

  return (
    <div className="membersTabularView">
      <Tabs
        onSelect={(id) => {
          dispatch(setActiveTab({ id }));
        }}
        defaultIndex={selected ? selected : 0}>
        <TabList>
          <Tab>기본정보</Tab>
          <Tab>근무일정</Tab>
          <Tab>근로계약</Tab>
        </TabList>

        <TabPanel>
          <TabOneView empData={empData} infoData={infoData} managerEditableEmpInfo={editableEmpInfo} />
        </TabPanel>
        <TabPanel>
          <TabTwoView
            infoData={infoData}
            schData={schData}
            toggleWorkType={toggleWorkType}
            removeSch={removeSch}
            managerEditableEmpInfo={editableEmpInfo}
          />
        </TabPanel>
        <TabPanel>
          <TabThreeView
            infoData={infoData}
            minDate={empData?.START ? new Date(empData.START) : undefined}
            date={date}
            handleSelectDate={handleSelectDate}
            payData={payData}
            monthPayData={monthPayData}
            managerEditableEmpInfo={editableEmpInfo}
          />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default MembersTabularView;
